module.exports = __webpack_public_path__ + "img/post6.6f0d30d8.png";